import Vue from 'vue'
import {helpers} from './../../helpers';

export default {
    store: {
        namespaced: true,
        state: {
            endpoint: 'storekeepers_stocks',
            stocks: [],
            responsibles: [],
            freights: [],
            freight: {},
            freightsSearch: [],
            currentFreightPage: 1,
            stock: {},
            itineraryFreight: [],
            itineraries: [],
            currentItinerary: {},
            deals_statuses: [],
            currentItinerariesPage: 1
        },
        mutations: {
            setCurrentFreightPage(state, page) {
                if (page) state.currentFreightPage = page;
            },
            unshiftFreight(state, freight) {
                state.freights.unshift(freight);
            },
            setCurrentItinerariesPage(state, page) {
                if (page) state.currentItinerariesPage = page;
            },
            unshiftItinerary(state, Itinerary) {
                state.itineraries.unshift(Itinerary);
            },
            changeItineraryFreight(state, val) {
                state.itineraryFreight = Object.assign([], val);
            },
            setCurrentItinerary(state, val) {
                state.currentItinerary = Object.assign({}, val);
            }
        },
        actions: {
            getFreights({ state, rootState }, data) {
                const concat = (data && data.concat) ? data.concat : false
                data = helpers.db.resolveGetParams(data);
                return helpers.http.get({context: this, rootState}, '/deals/freight', {params: data}).then(r => {
                    if (r && r.data && r.data.length) {
                        let freights = r.data;
                        if (concat) {
                            let temp = (state && state.freights) ? state.freights : [];
                            freights = Object.assign([], temp.concat(freights));
                        }
                        Vue.set(state, 'freights', freights);
                        Vue.set(state, 'freights_amount', r.total);
                    } else Vue.set(state, 'freights', []);
                    
                    return r;
                });
            },
            getFreightTracking({ rootState }, data) {
                let filter = {model: [['freight_id', '=', data.ids]]};
                return helpers.http.get({context: this, rootState}, '/deals/tracking', {params: {filter: filter}});
            },
            getTracking({ rootState }, data) {
                data = helpers.db.resolveGetParams(data);
                return helpers.http.get({context: this, rootState}, '/deals/tracking', {params: data});
            },
            getFreight({ state,rootState }, freightId) {
                return helpers.http.get({context: this, rootState}, `/deals/freight/byid/${freightId}`).then(r => {
                    Vue.set(state, 'freight', r);
                    return r;
                });
            },
            getFreightById({ rootState }, freightId) {
                return helpers.http.get({context: this, rootState}, '/deals/freight/byid/' + freightId);
            },
            getFreightByIdWS({ rootState }, freightId) {
                return helpers.http.get({context: this, rootState}, '/deals/freight/byid/' + freightId, { params: { cache: true } });
            },
            getFreightByTracking({ rootState }, code) {
                return helpers.http.get({context: this, rootState}, '/deals/freight/bycode/' + code);
            },
            //обновление груза
            updateFreight({ rootState }, data) {
                return helpers.http.put({context: this, rootState}, '/deals/freight', data);
            },
            getStorekeepersStocks({ state, rootState }, data) {
                data = {
                    count: data.count ? data.count : null,
                    page:  data.page  ? data.page  : null,
                    filter: (data.filter) ? data.filter : {model: [], relation: []}
                };
                return helpers.http.get({context: this, rootState}, '/stock', {params: data}).then(r => {
                    if (!r || !r.data) return null;
                    Vue.set(state, 'stocks', r.data);
                    Vue.set(state, 'stocks_amount', r.total);
                    return r;
                });
            },
            searchFreights({ state, rootState }, data) {
                data = helpers.db.resolveGetParams(data);
                return helpers.http.get({context: this, rootState}, '/deals/freight', {params: params}).then(r => {
                    Vue.set(state, 'freightsSearch', []);
                    if (r.data && r.data.length) Vue.set(state, 'freightsSearch', r.data);
                    return r.data;
                });
            },
            saveDeal({ rootState }, data) {
                return helpers.http.post({context: this, rootState}, '/deal', data);
            },
            saveBlankFreight({ rootState }, data) {
                return helpers.http.post({context: this, rootState}, '/deal/freight', data);
            },
            getStatuses({ state, rootState}, data) {
                data = {filter: (data && data.filter) ? data.filter : {model: [], relation: []}};
                return helpers.http.get({context: this, rootState}, '/deals/status', {params: data}).then(r => {
                    Vue.set(state, 'deals_statuses', r);
                    return r;
                });
            },
            getTrackingStatuses({ state, rootState }, data) {
                data = {filter: (data.filter) ? data.filter : {model: [], relation: []}};
                return helpers.http.get({context: this, rootState}, '/deals/tracking_status', {params: data}).then(r => {
                    Vue.set(state, 'freight_statuses', r);
                    return r;
                });
            },

            getCity({ rootState }, id) {
                return helpers.http.get({context: this, rootState}, '/city/byid/' + id);
            }
        }
    }
}


// WEBPACK FOOTER //
// ./src/modules/storekeepers_stocks/store.js